import { render, staticRenderFns } from "./OctIcon.vue?vue&type=template&id=5bd86965&"
import script from "./OctIcon.vue?vue&type=script&lang=js&"
export * from "./OctIcon.vue?vue&type=script&lang=js&"
import style0 from "./OctIcon.vue?vue&type=style&index=0&id=5bd86965&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports